// DecisionModal.jsx
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Formik, Form, useField } from "formik";
import * as Yup from "yup";
import styles from "./decisionModal.module.css";
import { BackButton, Submit } from "../../../../components/button/buttons";
import { TextArea } from "../../controllers/quotationControllers";
import { useBodyScrollLock } from "../../../../utils/utils";
import IMAGES from "../../../../assets/images/images";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";

export default function DecisionModal({ action,requestId, quotationdata,...props}) {
  const [isSubmit, setIsSubmit] = useState(false)
  const isReject = action === DEMAND_ACTIONS.REJECT_QUOTATION;
  const isAccept = action === DEMAND_ACTIONS.APPROVE_QUOTATION;
  const MAX = 500;
  useBodyScrollLock(action?true:false);

  const schema = React.useMemo(
    () =>
      Yup.object({
        reason: Yup.string()
          .trim()
          .required(isReject ? "Rejection reason is required" : "Comments are required")
          .max(MAX, `Maximum ${MAX} characters allowed`),
      }),
    [action]
  );

  const title = isReject ? "Request Quotation Revision" : "Accept Quotation";
  const actionText = isReject ? "Yes" : "Yes";

  const onClose=() => props?.setDecisionModal(null)

  return createPortal(
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
           <img className={styles.crosicon} src={IMAGES.close}  onClick={onClose} alt="Information icon"/>
        </div>
        <Formik
          initialValues={{ reason: "" }}
          validationSchema={schema}
          validateOnMount
          onSubmit={(vals) => {
            const payload = {
              action: action,
              stateData: {comment: vals?.reason,quotationDocUniqueId:quotationdata?.quotationDocUniqueId,floorPriceDocUniqueId:quotationdata?.floorPriceDocUniqueId}
            }
              // ____OLD_PAYLOAD___
              
            // const payload = {
            //   action: DEMAND_ACTIONS.REVIEW_QUOTATION,
            //   stateData: {
            //     ...quotationdata,
            //     comment: vals?.reason,
            //     accepted: action===DEMAND_ACTIONS.APPROVE_QUOTATION?true:false,
            //   }}
            setIsSubmit(true);
            props?.addDemandAction(payload,requestId)
            .then((res) => {
              if(res){
                props?.openAlertPopup({
                  message: action === DEMAND_ACTIONS.APPROVE_QUOTATION ? "Quotation accepted successfully." : "Quotation has been returned to the Vodafone team for further review.",
                  image: IMAGES.success
                });
                props.handelServiceDetailapi();
              }else{
                props?.openAlertPopup({
                message: "An error occurred while processing your request. Please try again later.",
                image: IMAGES.error
              });
              }
            })
            .catch((error) => {
              props?.openAlertPopup({
                message: "An error occurred while processing your request. Please try again later.",
                image: IMAGES.error
              });
            })
            .finally(() => {
              setIsSubmit(false);
              props?.setDecisionModal(null)
            });
          }}
        >
          {({ values, isValid }) => (
            <Form className={styles.body}>
              <div className={styles.field}>
                <TextArea
                  name="reason"
                  label={isReject ? "Comments" : "Comments"}
                  isMandatory={true}
                  isPreviewMode={false}
                  placeholder={
                    isReject
                      ? "Add revision details"
                      : "Add confirmation notes"
                  }
                  textLimit={`${values.reason?.length}/${MAX} characters`}
                  rows={6}
                  maxLength={MAX}
                  count={values.reason?.length}
                />
                <div className={styles.helperRow}>
                  <div className={styles.helperText}>
                    {isReject
                      ? <><div>
                        Sending the quotation back will notify the Vodafone team to review and update it based on your comments. You will be informed once the revised quotation is shared with you.
                        </div>
                        <div>
                          Do you want to continue?
                        </div>
                        </>
                      : <><div>Accepting this quotation will confirm your approval and notify the Vodafone team to proceed.</div> <div>This action is irreversible. Do you want to continue?</div></>}
                  </div>
                  {/* <div className={styles.counterText}>
                    {MAX - (values.reason?.length || 0)} characters remaining
                  </div> */}
                </div>
                {/* {isReject ? (
                  <div className={styles.note}>
                    <img className={styles.noteinfo} src={IMAGES.infoCircle} alt="Information icon"/>
                    <div className={styles.rejectnote}>
                      The quotation will be revised based on your feedback and resubmitted.
                      The 30-days response window will reset upon resubmission.
                    </div>
                  </div>
                ) : null} */}
              </div>
              <div className={`${styles.footerwrapper}`}>
                <div className={styles.footer}>
                  <BackButton
                    type="button"
                    className={styles.backButton}
                    closePopup={onClose}
                    disabled = {isSubmit}
                    title={"No"}
                  />
                  <Submit
                    type={"submit"}
                    style={`${styles.submit}`}
                    title={actionText}
                    isSubmitting={isSubmit}
                    disabled={isSubmit || !isValid}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>,
    document.body
  );
}